export default "/fonts/vendor/react-notifications/lib/notification.eot?3657084dc0419605a91c99b81968c9d4";